import React from 'react';
import { Spin } from 'antd';
import { CheckCircleOutlined, WarningOutlined } from '@ant-design/icons';

const ToolStatusBlock = ({ label, status }) => (
  <div className={`agent-tool-status agent-tool-status-${status}`}>
    {status === 'running' && <Spin size="small" />}
    {status === 'done' && <CheckCircleOutlined style={{ color: '#7a9c2e' }} />}
    {status === 'error' && <WarningOutlined style={{ color: '#d4843a' }} />}
    <span>{label}{status === 'running' ? '…' : ''}</span>
  </div>
);

export default ToolStatusBlock;
